import { statisticsConstants } from '../_constants';

export function insertstatitics(state = {}, action) {
  switch (action.type) {
    case statisticsConstants.INSERT_REQUEST:
      return { registering: true };
    case statisticsConstants.INSERT_SUCCESS:
      return {
        registered:true
      };
    case statisticsConstants.INSERT_FAILURE:
      return {};
    default:
      return state
  }
}